import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b4987nejrq: FaireBrandEntity = {
  token: "b_b4987nejrq",
  type: "brand",
  name: "Anokhi Green",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb45ac76242cf74c9c8464828122d8d4b68542b7303839cc99f04fed80d93f01.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9397ef50fcfad8456cdae1fb2bb842753377cd16483aaaf38e8503f322fc0856.png",
  logoUrl:
    "https://cdn.faire.com/fastly/eb45ac76242cf74c9c8464828122d8d4b68542b7303839cc99f04fed80d93f01.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9397ef50fcfad8456cdae1fb2bb842753377cd16483aaaf38e8503f322fc0856.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 72,
  isTopShop: true,
  isInsider: true,
  description:
    'Hello, I\'m Pam, the founder of Anokhi Green.  After retiring from a fulfilling career as a nurse, I took my first step in designing gemstone jewelry. The response was overwhelmingly positive, and it ignited my passion to take Anokhi Green to the next level.  Today, I am proud to operate a workshop in Jaipur, India, where I collaborate with a team of incredibly talented artisans.  Our commitment to fair trade practices and ethical craftsmanship has earned us an invitation to the  Chicago Fair Trade Association. Our jewelry is sold online and in boutiques across the country. \n\nAnokhi, which translates to "unique" in Hindi, perfectly encapsulates the essence of our gemstone jewelry. Each piece is not just an accessory but a story for those that love gemstones.  The gemstone beads are purchased in small batches so get them while you can!\n\nWe are committed to giving back.  Anokhi Green is a proud supporter of the Chicago Fair Trade Association and Operation Shanti, an orphanage for street children in Mysore, India. ',
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:07.972Z",
    importedBy: "entity-db-cli",
  },
};
